import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {DxGridToolbarAction} from "../../dx-grid/domain/ui-options/toolbar/dx-grid-toolbar-action";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";
import {BdpkSchedule} from "../../bdpk-tasks/domain/bdpk-schedule";

@jsonObject
export class BdpkObject extends DxGridRow {

  get id() {
    return this.objectId;
  }

  /** ID объекта **/
  @jsonMember({name: "objectId", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _objectId: number;

  /** ID связанной папки **/
  @jsonMember({name: "folderId", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _folderId: number;

  @jsonMember({name: "analyticalTaskId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _analyticalTaskId: number;

  /** Название отчета **/
  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  protected _name: string;

  /** Текстовое описание */
  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  protected _description: string;

  /** Идентификатор типа объекта */
  @jsonMember({name: "objectTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _objectTypeId: number;

  /** Название типа объекта */
  @jsonMember({name: "objectTypeImagePath", constructor: String, emitDefaultValue: false, isRequired: false })
  private _objectTypeImagePath: string;

  /** Название типа объекта */
  @jsonMember({name: "objectTypeName", constructor: String, emitDefaultValue: false, isRequired: false })
  protected _objectTypeName: string;

  /** Ссылка на отчет или документ */
  @jsonMember({name: "filePath", constructor: String, emitDefaultValue: false, isRequired: false })
  protected _filePath: string;

  /** Признак файла */
  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  isFile: boolean;

  /** Признак запускаемости */
  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  isRun: boolean;

  /** Признак "задаваемости расписания" */
  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  isSchedule: boolean;


  /** Дата создания */
  @jsonMember({name: "createDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  protected _createDate: Date;

  /** Идентификатор пользователя */
  @jsonMember({name: "createUserId", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _createUserId: number;

  /** Дата последнего обновления */
  @jsonMember({name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  protected _changeDate: Date;

  /** Идентификатор пользователя */
  @jsonMember({name: "changeUserId", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _changeUserId: number;

  /** Порядок */
  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _ord: number;

  /** Признак избранной задачи */
  @jsonMember({name: "isFavorite", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  protected _isFavorite: boolean;

  /** Ссылка на постоянную часть среды разработки */
  @jsonMember({name: "objectTypeDeTypeLink", constructor: String, emitDefaultValue: false, isRequired: false })
  private _objectTypeDeTypeLink: string;

  @jsonArrayMember(Number, {emitDefaultValue: false, preserveNull: false, isRequired: false})
  privileges: number[] = [];

  /**
   *  non-serializable object
   */
  schedules: BdpkSchedule[];

  /** показ кнопок на тулбаре */
  canExecuteToolbarAction(action: DxGridToolbarAction): boolean {
    switch (action.type) {
      case 'DOWNLOAD':
        return this.isFile;
      case 'START':
        return this.isRun;
      case 'OPEN':
        return !this.isFile;
      case 'SCHEDULE':
        return this.isSchedule;
    }
    return true;
  }


  get objectId(): number {
    return this._objectId;
  }

  set objectId(value: number) {
    this._objectId = value;
  }

  get folderId(): number {
    return this._folderId;
  }

  set folderId(value: number) {
    this._folderId = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get objectTypeName(): string {
    return this._objectTypeName;
  }

  set objectTypeName(value: string) {
    this._objectTypeName = value;
  }

  get createDate(): Date {
    return this._createDate;
  }

  set createDate(value: Date) {
    this._createDate = value;
  }

  get isFavorite(): boolean {
    return this._isFavorite;
  }

  set isFavorite(value: boolean) {
    this._isFavorite = value;
  }

  get filePath(): string {
    return this._filePath;
  }

  set filePath(value: string) {
    this._filePath = value;
  }

  get objectTypeId(): number {
    return this._objectTypeId;
  }

  set objectTypeId(value: number) {
    this._objectTypeId = value;
  }

  get createUserId(): number {
    return this._createUserId;
  }

  set createUserId(value: number) {
    this._createUserId = value;
  }

  get changeDate(): Date {
    return this._changeDate;
  }

  set changeDate(value: Date) {
    this._changeDate = value;
  }

  get changeUserId(): number {
    return this._changeUserId;
  }

  set changeUserId(value: number) {
    this._changeUserId = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get analyticalTaskId(): number {
    return this._analyticalTaskId;
  }

  set analyticalTaskId(value: number) {
    this._analyticalTaskId = value;
  }

  get objectTypeImagePath(): string {
    return this._objectTypeImagePath;
  }

  set objectTypeImagePath(value: string) {
    this._objectTypeImagePath = value;
  }

  get objectTypeDeTypeLink(): string {
    return this._objectTypeDeTypeLink;
  }

  set objectTypeDeTypeLink(value: string) {
    this._objectTypeDeTypeLink = value;
  }
}
